import { FlexBox, H5 } from '@helloself/hello-self-ui';
import Skeleton from 'react-loading-skeleton';

import List from '../List';
import Tile from '../Tile';
import ListEntry, { ListEntryProps } from './ListEntry';

export interface ListWithIconProps {
    header: string;
    entries?: ListEntryProps[];
    isLoadingEntries?: boolean;
}

const ListWithIcon = ({ header, entries, isLoadingEntries }: ListWithIconProps) => {
    if (isLoadingEntries) {
        return (
            <Tile>
                <H5 margin={'0 0 24px'}>{header}</H5>
                <FlexBox alignItems="center">
                    <Skeleton width="48px" height="48px" borderRadius="24px" style={{ marginRight: '12px' }} />
                    <Skeleton width="280px" height="24px" />
                </FlexBox>
            </Tile>
        );
    }

    if (!entries || entries.length === 0) {
        return null;
    }

    const iconList = entries.map((entry) => (
        <List.Item key={`${entry.name}-${entry.organisation}`}>
            <ListEntry {...entry} />
        </List.Item>
    ));

    return (
        <Tile>
            <H5 margin={'0 0 24px'}>{header}</H5>
            <List>{iconList}</List>
        </Tile>
    );
};

export default ListWithIcon;
